import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      title: "IT Consulting",
      description: "Every Journey starts with that one step and so does the growth of your organization. we are the next step that will help you cruise through the hardships and take you to your Zenith.",
      icon: "💻",
    },
    // {
    //   title: "Mobile App Development",
    //   description: "Developing user-friendly and efficient mobile applications.",
    //   icon: "📱",
    // },
    // {
    //   title: "Cloud Solutions",
    //   description: "Offering scalable and secure cloud computing services.",
    //   icon: "☁️",
    // },
    // {
    //   title: "IT Consultancy",
    //   description: "Providing expert guidance for your IT strategy and operations.",
    //   icon: "💼",
    // },
    // {
    //   title: "AI Solutions",
    //   description: "Leveraging AI to drive innovation and efficiency in your business.",
    //   icon: "🤖",
    // },
    // {
    //   title: "Cybersecurity",
    //   description: "Ensuring the safety and security of your digital assets.",
    //   icon: "🔒",
    // },
  ];

  // Framer Motion Variants
  const containerVariants = {
    hidden: { opacity: 0, y:50 },
    visible: {
      opacity: 1,
      y:0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 0.7,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="services-section py-24 bg-gradient-to-r from-black to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-white mb-4">
            Our Services
          </h2>
          <p className="text-lg text-gray-300">
            Empowering businesses with innovative IT solutions tailored to your
            needs.
          </p>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12"
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              viewport={{ once: false, amount: 0.2 }}
              className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-2xl hover:scale-110 transform transition-all duration-300"
            >
              <div className="flex items-center justify-center mb-4 text-4xl">
                {service.icon}
              </div>
              <h3 className="text-2xl font-semibold mb-2 text-white">
                {service.title}
              </h3>
              <p className="text-gray-300">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>
        <Link
              to="/services"
              className="inline-block no-underline mt-6 text-white bg-blue-600 hover:bg-blue-700 px-8 py-3 rounded-full shadow-lg transform hover:scale-110 transition-transform duration-300"
            >
              Get In Touch
            </Link>
      </div>
    </section>
  );
};

export default Services;
